











import './KisweSpinner.scss'
import { defineComponent } from '@vue/composition-api'
import { useSizes, useThemes } from '../../compositions'
import { KisweSize, KisweTheme } from '../../types'
import KisweIcon from '../../components/KisweIcon'

export default defineComponent({
  name: 'KisweSpinner',
  components: {
    KisweIcon
  },
  props: {
    ...useSizes({ size: KisweSize.Medium }).props,
    ...useThemes({ theme: KisweTheme.None }).props
  }
})
